export default "__VITE_ASSET__CbWzf93s__"